'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _actions = ['INIT_WEB', // Params: i18nUxMode(boolean), queryHash(QueryUtils)
'LOAD_FULL', // Params: none
'LOAD_FULL_SUCCESS', // Params: {full:full}
'LOAD_FULL_FAILURE' // Params: {error}
];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions);
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/restaurants-redux/dist/actions/WebInitActions.js
// module id = 162
// module chunks = 0